interface TriangleWarningIconProps {
  className?: string;
  title?: string;
  "aria-hidden"?: boolean | "true" | "false";
}

const TriangleWarningIcon = ({
  className,
  title,
  "aria-hidden": ariaHidden,
}: TriangleWarningIconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden={ariaHidden}
    >
      {title && <title>{title}</title>}
      <path
        d="M12 6.49L19.53 19.5H4.47L12 6.49ZM12 2.5L1 21.5H23L12 2.5Z"
        fill="#ED6C02"
      />
      <path d="M13 16.5H11V18.5H13V16.5Z" fill="#ED6C02" />
      <path d="M13 10.5H11V15.5H13V10.5Z" fill="#ED6C02" />
    </svg>
  );
};

export default TriangleWarningIcon;
